import{jsx as e}from"react/jsx-runtime";import r from"./styles.module.css";let Center=t=>{let{children:s}=t;return e("section",{className:`${r.center}`,children:e("article",{children:s})})};export{Center as C};
